
import React from 'react';
import { Button } from '@/components/ui/button';
import { ShoppingCart, RefreshCw, Gift as GiftIcon, Wallet } from 'lucide-react';
import { type MarketAction } from '@/utils/types';

interface ActionButtonsProps {
  activeAction: MarketAction;
  onActionChange: (action: MarketAction) => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ activeAction, onActionChange }) => {
  const handleActionChange = (action: MarketAction) => {
    console.log("ActionButtons: Changing action to:", action);
    onActionChange(action);
  };

  return (
    <div className="grid grid-cols-4 gap-2 w-full">
      <Button 
        variant={activeAction === 'consume' ? 'default' : 'outline'}
        className={activeAction === 'consume' ? 'bg-givgo-purple hover:bg-givgo-purple/90' : ''}
        onClick={() => handleActionChange('consume')}
      >
        <ShoppingCart className="h-4 w-4 mr-2" /> Use
      </Button>
      <Button 
        variant={activeAction === 'exchange' ? 'default' : 'outline'} 
        className={activeAction === 'exchange' ? 'bg-givgo-purple hover:bg-givgo-purple/90' : ''}
        onClick={() => handleActionChange('exchange')}
      >
        <RefreshCw className="h-4 w-4 mr-2" /> Exchange
      </Button>
      <Button 
        variant={activeAction === 'regift' ? 'default' : 'outline'}
        className={activeAction === 'regift' ? 'bg-givgo-purple hover:bg-givgo-purple/90' : ''}
        onClick={() => handleActionChange('regift')}
      >
        <GiftIcon className="h-4 w-4 mr-2" /> Re-Gift
      </Button>
      <Button 
        variant={activeAction === 'convert' ? 'default' : 'outline'}
        className={activeAction === 'convert' ? 'bg-givgo-purple hover:bg-givgo-purple/90' : ''}
        onClick={() => handleActionChange('convert')}
      >
        <Wallet className="h-4 w-4 mr-2" /> Convert
      </Button>
    </div>
  );
};

export default ActionButtons;
